"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Logout = require("./Logout.scss");

var _Logout2 = _interopRequireDefault(_Logout);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _reactRedux = require("react-redux");

var _auth = require("../../redux/modules/auth");

var _glamor = require("glamor");

var _RedirectToExternalSite = require("./../../utils/RedirectToExternalSite");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logout = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Logout, _Component);

  function Logout(props) {
    (0, _classCallCheck3.default)(this, Logout);
    return (0, _possibleConstructorReturn3.default)(this, (Logout.__proto__ || (0, _getPrototypeOf2.default)(Logout)).call(this, props));
  }

  (0, _createClass3.default)(Logout, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          logout = _props.logout,
          loggedIn = _props.loggedIn,
          location = _props.location;

      if (!loggedIn) {
        var return_to = location.query.return_to;


        if (return_to && return_to.indexOf("megascans/library") > -1) {
          if (__CLIENT__) {
            (0, _RedirectToExternalSite.checkRedirectRequired)(return_to);
          }
          return;
        } else {
          this.context.router.push({
            pathname: "/"
          });
        }
      } else {
        if (window) {
          window.localStorage.setItem("quixelLogin", false);
        }
        logout();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (nextProps.loggingOut !== this.props.loggingOut) {
        var return_to = this.props.location.query.return_to;


        if (return_to && return_to.indexOf("megascans/library") > -1) {
          if (__CLIENT__) {
            (0, _RedirectToExternalSite.checkRedirectRequired)(return_to);
          }
          return;
        } else {
          this.context.router.push({
            pathname: "/"
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var loggingOut = this.props.loggingOut;


      if (!loggingOut) {
        return _react2.default.createElement("div", { className: (0, _glamor.css)({ height: "100vh" }) });
      }

      return _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)({ height: "100vh" }) },
        _react2.default.createElement(
          "div",
          { className: _Logout2.default.overlay },
          _react2.default.createElement(
            "div",
            { className: _Logout2.default.wrap },
            _react2.default.createElement(
              "div",
              { className: _Logout2.default.preloader },
              _react2.default.createElement(_Preloader2.default, null)
            ),
            _react2.default.createElement(
              "span",
              { className: _Logout2.default.label },
              "Signing out..."
            )
          )
        )
      );
    }
  }]);
  return Logout;
}(_react.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    loggingOut: state.auth.loggingOut,
    loggedIn: state.auth.loggedIn
  };
}, { logout: _auth.logout })(Logout);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Logout/Logout.jsx
// module id = 2635
// module chunks = 0